import React, { useContext, useState } from 'react';
import { Box, useTheme } from '@mui/material';
import Header from 'widgets/header/header';
import { observer } from 'mobx-react-lite';
import Footer from '../../widgets/footer/footer';
import Modal from 'shared/lib/components/modals/modal';
import MainMenuModal from 'widgets/mainMenu/mainMenuModal';
import { MobxContext } from 'shared/lib/contexts/mobxContext';
import { UiContext } from 'shared/lib/contexts/uiContext';
import { defaultSpacingPresets } from 'shared/hooks/useGetSpacing';

export default observer(function PageHolder({
  children,
}: {
  children: React.ReactNode;
}) {
  const {
    mobxStore: { authStore },
  } = useContext(MobxContext);
  const {
    spacings: { sp },
  } = useContext(UiContext);
  const theme = useTheme();

  const [isMainMenuOpen, setIsMainMenuOpen] = useState<boolean>(false);

  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        minHeight: '100vh',
      }}
    >
      <Header onMainMenuClick={() => setIsMainMenuOpen(true)}></Header>
      <Box
        sx={{
          display: 'flex',
          flexShrink: 0,
          width: 1,
          flexDirection: 'column',
          flexGrow: 1,
        }}
      >
        {children}
      </Box>
      <Footer></Footer>

      <Modal
        isOpen={isMainMenuOpen}
        handleClose={() => setIsMainMenuOpen(false)}
        sx={{
          '& .MuiDialog-container': {
            alignItems: 'flex-start',

            [theme.breakpoints.up('laptop')]: {
              justifyContent: 'flex-end',
            },
          },
          '& .MuiDialog-paper': {
            p: '',
            m: '',
            width: defaultSpacingPresets.modals.menuModalW,
          },
        }}
        iconStyle={{ top: theme.spacing(sp.s50), right: theme.spacing(sp.s50) }}
      >
        <MainMenuModal
          handleLogout={() => authStore.logout()}
          handleCloseMainMenu={() => setIsMainMenuOpen(false)}
        ></MainMenuModal>
      </Modal>
    </Box>
  );
});
